import React from 'react';
import { Check } from 'lucide-react';
interface TimeSlotPickerProps {
  times: string[];
  capacity: number;
  /** Booked people per time. undefined = loading, null = couldn't be read */
  counts: Record<string, number> | null | undefined;
  selected: string | null;
  onSelect: (time: string) => void;
  error: string | null;
}
export function TimeSlotPicker({
  times,
  capacity,
  counts,
  selected,
  onSelect,
  error
}: TimeSlotPickerProps) {
  return <fieldset aria-describedby={error ? 'su-slot-error' : undefined} data-id="element-1348" data-mp="2vc6or5ls0wl6">
      <legend className="block text-xs font-semibold text-[#F5EDE3]/70 mb-1.5" data-id="element-1349" data-mp="30cuapcv5en8j">
        Välj tid *
      </legend>
      <div className="grid grid-cols-3 gap-2" data-id="element-1350" data-mp="2mdbglnz69cf8">
        {times.map((time, i) => {
        const isSelected = selected === time;
        const left = counts ? Math.max(0, capacity - (counts[time] ?? 0)) : null;
        const full = left === 0;
        return <label key={time} className={`relative flex flex-col items-center justify-center rounded-xl border px-2 py-2.5 cursor-pointer transition-colors duration-150 ${isSelected ? 'border-[#FF7A1A] bg-[#FF7A1A]/10' : error ? 'border-[#F87171] bg-[#0E0C0B]' : 'border-[#F5EDE3]/15 bg-[#0E0C0B] hover:border-[#F5EDE3]/35'}`} data-id="element-1351" data-mp="1fyagr7710a3d" data-mpi={i}>
              <input id={`su-slot-${i}`} type="radio" name="time-slot" value={time} checked={isSelected} onChange={() => onSelect(time)} className="sr-only peer" data-id="element-1352" data-mp="1s9qzu37cw51i" />
              <span className="absolute inset-0 rounded-xl peer-focus-visible:ring-2 peer-focus-visible:ring-[#FF7A1A]/60 pointer-events-none" data-id="element-1353" data-mp="1x0pllib45vc5" />
              <span className="flex items-center gap-1 text-base font-bold tabular-nums text-[#F5EDE3]" data-id="element-1354" data-mp="2b1a3mc97fn4l">
                {isSelected && <Check className="w-3.5 h-3.5 text-[#FF9A4D]" strokeWidth={3} aria-hidden="true" data-id="element-1355" data-mp="2e2ve7u2osf9m" />}
                {time}
              </span>
              <span className={`mt-0.5 text-[11px] font-medium whitespace-nowrap ${full ? 'text-[#FFB27A]' : 'text-[#F5EDE3]/50'}`} data-id="element-1356" data-mp="2o014j03h828s">
                {counts === undefined ? 'Hämtar…' : full ? 'Väntelista' : 'Ledig'}
              </span>
            </label>;
      })}
      </div>
      {!error && <p className="mt-2 text-xs text-[#F5EDE3]/55 leading-relaxed" data-id="element-1357" data-mp="3bqdhipdkwp68">
          Begränsat antal platser per tid. När en tid är fullbokad visas{' '}
          <span className="font-semibold text-[#FFB27A]" data-id="element-1358" data-mp="1cekspg0y2q4l">Väntelista</span> och
          du kan ställa dig på väntelistan för den tiden.
        </p>}
      {error && <p id="su-slot-error" className="mt-1.5 text-xs font-medium text-[#FCA5A5]" data-id="element-1359" data-mp="3umvw9clhbei7">
          {error}
        </p>}
    </fieldset>;
}